import React, { Children as H } from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import classNames from "classnames"

import Styles from "./tabs.less"

export default createReactClass({
  propTypes: {
    className: PropTypes.string,
    activeTab: PropTypes.string,
    onChangeTab: PropTypes.func,
  },
  handleClick(url) {
    this.props.onChangeTab(url)
  },
  getClass() {
    return classNames(Styles.tabs, this.props.className)
  },
  getTabs() {
    return (this.props.tabHeaders || []).map((h) => this.cloneElementPassProps(h))
  },
  cloneElementPassProps(child) {
    return React.cloneElement(child, this.getNewProps(child.props.url))
  },
  getNewProps(url) {
    return {
      key: url,
      handleClick: this.handleClick.bind(this, url),
      isActive: this.props.activeTab === url,
    }
  },
  getContent() {
    var self = this
    var currentChild = _.find(H.toArray(this.props.children), function (child) {
      return child.props.url === self.props.activeTab && child.type.displayName === "TabContent"
    })

    return currentChild
  },
  render() {
    return (
      <div className={this.props.containerClassName}>
        <div className={this.getClass()}>
          {this.getTabs()}
          <div style={{ clear: "both" }} />
        </div>
        <div className={classNames(Styles.content, this.props.contentClassName)}>
          {this.getContent()}
        </div>
      </div>
    )
  },
})
